import {getIconColorClassName, getIconComponent} from '@github-ui/saved-views'
import {clsx} from 'clsx'

import styles from './SidebarLinkIcon.module.css'

export function SidebarLinkIcon({name, color}: {name: string; color: string}) {
  const IconComponent = getIconComponent(name)
  return (
    <div className={clsx(styles.icon, getIconColorClassName(color))}>
      {/* eslint-disable-next-line react-hooks/static-components -- I'm not creating a component here, getIconComponent is just selecting along a lot of static icon components */}
      <IconComponent />
    </div>
  )
}
